import type { NavSection, UserRole } from '@/types'

const accountNav: NavSection = {
  title: 'Account',
  items: [
    { label: 'My Profile', to: '/profile', icon: 'user-circle' },
    { label: 'Notifications', to: '/notifications', icon: 'bell' },
  ],
}

const trainerNav: NavSection[] = [
  {
    items: [{ label: 'Dashboard', to: '/trainer/dashboard', icon: 'tachometer-alt' }],
  },
  {
    title: 'Attendance',
    items: [
      { label: 'Mark Attendance', to: '/trainer/attendance', icon: 'clipboard-list' },
      { label: 'Biometric Attendance', to: '/trainer/biometric', icon: 'fingerprint' },
      { label: 'View & Download Attendance', to: '/trainer/attendance-history', icon: 'download' },
    ],
  },
  {
    title: 'Assessments',
    items: [
      { label: 'Trainee POE Review', to: '/trainer/assessments', icon: 'tasks' },
      { label: 'Marks Entry', to: '/trainer/marks-entry', icon: 'edit' },
      { label: 'Import Marks', to: '/trainer/marks-import', icon: 'file-excel' },
      { label: 'Summative Assessments', to: '/summative', icon: 'award' },
      { label: 'My Portfolio (POE)', to: '/trainer/portfolio', icon: 'folder-open' },
    ],
  },
  {
    title: 'Trips',
    items: [
      { label: 'Trip Reports', to: '/academic-trips', icon: 'bus' },
    ],
  },
  {
    title: 'Clearance',
    items: [{ label: 'Clearance Approvals', to: '/clearance/approver', icon: 'clipboard-check' }],
  },
  accountNav,
]

const studentNav: NavSection[] = [
  {
    title: 'Overview',
    items: [{ label: 'Dashboard', to: '/student/dashboard', icon: 'tachometer-alt' }],
  },
  {
    title: 'Learning',
    items: [
      { label: 'My Units', to: '/student/units', icon: 'book-open' },
      { label: 'Lesson Attendance', to: '/student/attendance', icon: 'clipboard-list' },
      { label: 'Marks & Transcripts', to: '/student/marks', icon: 'chart-line' },
      { label: 'Portfolio of Evidence', to: '/student/portfolio', icon: 'folder-open' },
      { label: 'My Assessments', to: '/student/assessments', icon: 'file-alt' },
    ],
  },
  {
    title: 'Records',
    items: [{ label: 'My Documents', to: '/student/documents', icon: 'archive' }],
  },
  {
    title: 'Exams',
    items: [
      { label: 'Exam Booking Form', to: '/student/exam-booking-form', icon: 'file-signature' },
      { label: 'My Exam Bookings', to: '/student/exam-bookings', icon: 'calendar-check' },
    ],
  },
  {
    title: 'Industrial Attachment',
    items: [
      { label: 'Attachment Placement', to: '/student/industrial-attachment', icon: 'industry' },
      { label: 'Digital Logbook', to: '/student/logbook', icon: 'book' },
      { label: 'My Attachment Marks', to: '/student/attachment-marks', icon: 'star-half-alt' },
      { label: 'Mentoring Tool / Logbook', to: '/student/mentoring-tool', icon: 'file-pdf' },
    ],
  },
  {
    title: 'Services',
    items: [
      { label: 'Course Clearance', to: '/clearance', icon: 'clipboard-check' },
      { label: 'Employment Status', to: '/student/employment-status', icon: 'user-tie' },
    ],
  },
  accountNav,
]

const deptAdminNav: NavSection[] = [
  { items: [{ label: 'Dashboard', to: '/dept-admin/dashboard', icon: 'tachometer-alt' }] },
  {
    title: 'Academic Setup',
    items: [
      { label: 'Courses', to: '/dept-admin/courses', icon: 'graduation-cap' },
      { label: 'Classes', to: '/dept-admin/classes', icon: 'chalkboard' },
      { label: 'Units', to: '/dept-admin/units', icon: 'book' },
      { label: 'Trainers', to: '/dept-admin/trainers', icon: 'chalkboard-teacher' },
      { label: 'Students', to: '/dept-admin/students', icon: 'user-graduate' },
      { label: 'Assign Units', to: '/dept-admin/assign-units', icon: 'link' },
    ],
  },
  {
    title: 'Operations',
    items: [
      { label: 'Attendance', to: '/dept-admin/attendance', icon: 'clipboard-list' },
      { label: 'Assessments', to: '/dept-admin/assessments', icon: 'tasks' },
      { label: 'Exam Bookings', to: '/dept-admin/exam-bookings', icon: 'calendar-check' },
      { label: 'Marks', to: '/dept-admin/marks', icon: 'chart-line' },
      { label: 'Trainee POE', to: '/dept-admin/trainee-poe', icon: 'folder-open' },
      { label: 'Summative', to: '/summative', icon: 'award' },
    ],
  },
  {
    title: 'Attachment',
    items: [
      { label: 'Companies', to: '/dept-admin/companies', icon: 'building' },
      { label: 'Attachments', to: '/dept-admin/attachments', icon: 'industry' },
      { label: 'Logbooks', to: '/dept-admin/logbooks', icon: 'book' },
      { label: 'Applications', to: '/dept-admin/applications', icon: 'file-alt' },
    ],
  },
  {
    title: 'Clearance',
    items: [{ label: 'Clearance Approvals', to: '/clearance/approver', icon: 'clipboard-check' }],
  },
  accountNav,
]

const superAdminNav: NavSection[] = [
  { items: [{ label: 'Dashboard', to: '/super-admin/dashboard', icon: 'tachometer-alt' }] },
  {
    title: 'Directory',
    items: [
      { label: 'Departments', to: '/super-admin/departments', icon: 'sitemap' },
      { label: 'Users', to: '/super-admin/users', icon: 'users' },
      { label: 'Audit Logs', to: '/super-admin/logs', icon: 'history' },
    ],
  },
  {
    title: 'Dept Admin tools',
    items: [{ label: 'Dept Admin Dashboard', to: '/dept-admin/dashboard', icon: 'building' }],
  },
  accountNav,
]

const examinationOfficerNav: NavSection[] = [
  { items: [{ label: 'Dashboard', to: '/examination-officer/dashboard', icon: 'tachometer-alt' }] },
  accountNav,
]

const industryMentorNav: NavSection[] = [
  { items: [{ label: 'Dashboard', to: '/industry-mentor/dashboard', icon: 'tachometer-alt' }] },
  accountNav,
]

const internalVerifierNav: NavSection[] = [
  { items: [{ label: 'Dashboard', to: '/internal-verifier/dashboard', icon: 'tachometer-alt' }] },
  accountNav,
]

const liaisonOfficerNav: NavSection[] = [
  { items: [{ label: 'Dashboard', to: '/liaison-officer/dashboard', icon: 'tachometer-alt' }] },
  {
    title: 'Attachment',
    items: [
      { label: 'Attachments', to: '/liaison-officer/attachments', icon: 'industry' },
      { label: 'Companies', to: '/liaison-officer/companies', icon: 'building' },
      { label: 'Logbooks', to: '/liaison-officer/logbooks', icon: 'book' },
      { label: 'Periods', to: '/liaison-officer/periods', icon: 'calendar' },
      { label: 'Attachment Marks', to: '/liaison-officer/attachment-marks', icon: 'star' },
      { label: 'Mentoring Tools', to: '/liaison-officer/mentoring-tools', icon: 'file-pdf' },
    ],
  },
  {
    title: 'Clearance',
    items: [{ label: 'Clearance Approvals', to: '/clearance/approver', icon: 'clipboard-check' }],
  },
  accountNav,
]

const cdaccVerifierNav: NavSection[] = [
  { items: [{ label: 'Dashboard', to: '/cdacc-verifier/dashboard', icon: 'tachometer-alt' }] },
  {
    title: 'Verification',
    items: [
      { label: 'Assessments', to: '/cdacc-verifier/assessments', icon: 'tasks' },
      { label: 'Marks', to: '/cdacc-verifier/marks', icon: 'chart-line' },
      { label: 'Trainee POE', to: '/cdacc-verifier/trainee-poe', icon: 'folder-open' },
      { label: 'Trainees', to: '/cdacc-verifier/trainees', icon: 'user-graduate' },
      { label: 'Attachment Marks', to: '/cdacc-verifier/attachment-marks', icon: 'star' },
    ],
  },
  accountNav,
]

const workshopTechnicianNav: NavSection[] = [
  { items: [{ label: 'Dashboard', to: '/workshop-technician/dashboard', icon: 'tachometer-alt' }] },
  {
    title: 'Clearance',
    items: [{ label: 'Clearance Approvals', to: '/clearance/approver', icon: 'clipboard-check' }],
  },
  accountNav,
]

const serviceDeptNav: NavSection[] = [
  { items: [{ label: 'Dashboard', to: '/service-dept/dashboard', icon: 'tachometer-alt' }] },
  {
    title: 'Clearance',
    items: [{ label: 'Clearance Approvals', to: '/clearance/approver', icon: 'clipboard-check' }],
  },
  accountNav,
]

const registrarNav: NavSection[] = [
  { items: [{ label: 'Dashboard', to: '/admin-oversight/registrar', icon: 'tachometer-alt' }] },
  {
    title: 'Clearance',
    items: [
      { label: 'Clearances', to: '/admin-oversight/registrar/clearances', icon: 'clipboard-check' },
      { label: 'Approver Queue', to: '/clearance/approver', icon: 'tasks' },
    ],
  },
  accountNav,
]

const deputyPrincipalNav: NavSection[] = [
  { items: [{ label: 'Dashboard', to: '/admin-oversight/deputy-principal', icon: 'tachometer-alt' }] },
  {
    title: 'Oversight',
    items: [
      { label: 'Academic', to: '/admin-oversight/deputy-principal/academic', icon: 'university' },
      { label: 'Clearances', to: '/admin-oversight/deputy-principal/clearances', icon: 'clipboard-check' },
      { label: 'Approver Queue', to: '/clearance/approver', icon: 'tasks' },
    ],
  },
  accountNav,
]

const qaNav: NavSection[] = [
  {
    items: [
      { label: 'Dashboard', to: '/admin-oversight/quality-assurance', icon: 'tachometer-alt' },
    ],
  },
  accountNav,
]

const clearanceOnlyNav: NavSection[] = [
  {
    items: [{ label: 'Clearance Approvals', to: '/clearance/approver', icon: 'clipboard-check' }],
  },
  accountNav,
]

const portalNav: Partial<Record<UserRole, NavSection[]>> = {
  trainer: trainerNav,
  student: studentNav,
  dept_admin: deptAdminNav,
  super_admin: superAdminNav,
  examination_officer: examinationOfficerNav,
  industry_mentor: industryMentorNav,
  internal_verifier: internalVerifierNav,
  liaison_officer: liaisonOfficerNav,
  cdacc_verifier: cdaccVerifierNav,
  workshop_technician: workshopTechnicianNav,
  library_hod: serviceDeptNav,
  sports_hod: serviceDeptNav,
  service_clearance_officer: serviceDeptNav,
  registrar: registrarNav,
  deputy_principal: deputyPrincipalNav,
  quality_assurance_officer: qaNav,
  environment_hod: clearanceOnlyNav,
  dean_students: clearanceOnlyNav,
  finance_officer: clearanceOnlyNav,
}

export function getPortalNav(role: UserRole): NavSection[] {
  return portalNav[role] || [
    {
      items: [{ label: 'Dashboard', to: getRoleHome(role), icon: 'tachometer-alt' }],
    },
    accountNav,
  ]
}

export function getRoleHome(role: UserRole): string {
  const map: Record<string, string> = {
    trainer: '/trainer/dashboard',
    student: '/student/dashboard',
    dept_admin: '/dept-admin/dashboard',
    super_admin: '/super-admin/dashboard',
    examination_officer: '/examination-officer/dashboard',
    industry_mentor: '/industry-mentor/dashboard',
    internal_verifier: '/internal-verifier/dashboard',
    liaison_officer: '/liaison-officer/dashboard',
    cdacc_verifier: '/cdacc-verifier/dashboard',
    workshop_technician: '/workshop-technician/dashboard',
    library_hod: '/service-dept/dashboard',
    sports_hod: '/service-dept/dashboard',
    service_clearance_officer: '/service-dept/dashboard',
    registrar: '/admin-oversight/registrar',
    deputy_principal: '/admin-oversight/deputy-principal',
    quality_assurance_officer: '/admin-oversight/quality-assurance',
    environment_hod: '/clearance/approver',
    dean_students: '/clearance/approver',
    finance_officer: '/clearance/approver',
  }
  return map[role] || '/login'
}

export function getPortalTitle(role: UserRole): string {
  const map: Record<string, string> = {
    trainer: 'TTTI Trainer Portal',
    student: 'TTTI Trainee Portal',
    dept_admin: 'Department Admin Portal',
    super_admin: 'Super Admin Portal',
    examination_officer: 'Examination Officer Portal',
    industry_mentor: 'Industry Mentor Portal',
    internal_verifier: 'Internal Verifier Portal',
    liaison_officer: 'Liaison Officer Portal',
    cdacc_verifier: 'CDACC Verifier Portal',
    workshop_technician: 'Workshop Technician Portal',
    library_hod: 'Library Portal',
    sports_hod: 'Games Portal',
    service_clearance_officer: 'Service Clearance Portal',
    registrar: 'Registrar Portal',
    deputy_principal: 'Deputy Principal Portal',
    quality_assurance_officer: 'Quality Assurance Portal',
  }
  return map[role] || 'TTTI Portal'
}
